<div #richTextEditor class="rich-text-editor-container" [ngClass]="{ inline: displayOnly || (inline && !isFocused), outOfFocus: !isFocused, readOnly: displayOnly || readOnly }">
  <quill-editor
    customToolbarPosition="bottom"
    [(ngModel)]="richText"
    (onContentChanged)="onContentChanged($event)"
    [modules]="modules"
    [placeholder]="getPlaceholder()"
    [readOnly]="readOnly || displayOnly"
    (onFocus)="focusHandler()"
    (onBlur)="blurHandler()"
    theme="ghQuillTheme">
    <div quill-editor-toolbar [hidden]="displayOnly || (inline ? !isFocused : false)" (click)="focusHandler()">
      <div class="selected-gif-preview" *ngIf="gif && gif.id">
        <gif-view [gifSize]="sizeOfGif.Small" [gif]="gif"></gif-view>

        <div class="remove-gif-btn" (click)="removeGif()">
          <span class="nc-icon-outline icon ui-1_simple-remove"></span>
        </div>
      </div>

      <span class="ql-formats" *ngIf="!displayOnly">
        <button type="button" class="ql-bold">
          <rich-text-editor-icon [icon]="icons.BOLD" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>
        <button type="button" class="ql-italic">
          <rich-text-editor-icon [icon]="icons.ITALIC" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>
        <button type="button" class="ql-strike">
          <rich-text-editor-icon [icon]="icons.STRIKE" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>
        <button type="button" class="ql-list" value="ordered">
          <rich-text-editor-icon [icon]="icons.ORDERED" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>
        <button type="button" class="ql-list" value="bullet">
          <rich-text-editor-icon [icon]="icons.BULLET" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>

        <div class="vertical-separator"></div>

        <button type="button" class="ql-link">
          <rich-text-editor-icon [icon]="icons.LINK" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>

        <add-gif *ngIf="!withoutGifs" [outOfFocus]="!isFocused" (gifSelected)="selectGif($event)" (open)="popupMenuOpen()" (close)="popupMenuClose($event)"></add-gif>

        <button type="button" class="mention-btn" (click)="showMentionMenu()">
          <rich-text-editor-icon [icon]="icons.MENTION" [outOfFocus]="!isFocused"></rich-text-editor-icon>
        </button>

        <emoji-picker [outOfFocus]="!isFocused" (selectedEmoji)="addEmoji($event)" (open)="popupMenuOpen()" (close)="popupMenuClose($event)"></emoji-picker>

        <button *ngIf="!hidePostButton" class="post-comment-btn" [ngClass]="{ disabled: !canPostComment() }" title="{{ 'post_a_comment' | localize }}" (click)="postComment()">
          <rich-text-editor-icon [icon]="icons.POST_COMMENT" [outOfFocus]="!isFocused" [disabled]="!canPostComment()"></rich-text-editor-icon>
        </button>
      </span>
    </div>
  </quill-editor>

  <ui-mention-popover *ngIf="mentionElRef" [user]="mentionPopoverUser" [sourceMentionEl]="mentionElRef" (closed)="mentionPopoverClosed()"></ui-mention-popover>
</div>
